 <template>
  <div>
    <div class="btn-wrapper d-flex justify-content-md-end justify-content-center">
      <button class="btn btn-primary wizard-btn next-btn mr-3" @click="$emit('input', 'REGIE')">
        Nouvelle Demande De Régie
      </button>
    </div>
    <div class="mt-3">
      <history-demands />
    </div>
  </div>
</template>

<script>
export default {
  name: 'StepOne',
  mounted() {
    localStorage.removeItem('model');
  },
  
  components: {
    HistoryDemands: () => import('../HistoryDemands.vue'),
  },
};
</script>

<style scoped></style>